/* KFH bundle finder (Bundle Guide quick quiz, restored from before commit 8474441): 4 steps (texture, how you
   wear it, length, fullness) and the result (real variants and prices, one add to cart, blended and singles
   alternatives). Data comes from kfh-guide-finder.liquid. */
(() => {
  const init = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    const data = JSON.parse(root.querySelector('[data-kfh-guide-data]').textContent);
    const s = data.strings;
    const $ = (sel) => root.querySelector(sel);
    const money = (c) => (window.KFH && window.KFH.money ? window.KFH.money(c) : `$${Math.round(c / 100)}`);
    const el = (tag, props = {}, ...kids) => { const e = Object.assign(document.createElement(tag), props); e.append(...kids); return e; };
    const landmarks = Object.fromEntries((data.landmarks || '').split('|').filter(Boolean).map((p) => p.split('=')));
    const state = { step: 0, wear: null, len: null, full: null, tex: Math.min(Math.max(data.startTexture, 0), data.textures.length - 1), texPicked: false, unsure: false, blend: false };
    const tex = () => data.textures[state.tex];
    const STEPS = 4;

    /* ---------- Finder ---------- */
    const finder = $('[data-kfh-finder]');
    const questions = finder ? JSON.parse(finder.querySelector('[data-kfh-finder-questions]').textContent) : [];
    const lengthsFor = (t) => {
      const v = t && t.single ? t.single.variants.map((x) => x.n) : data.lengths;
      return data.lengths.filter((n) => v.includes(n));
    };
    const option = (label, sub, on, pick, swatch) => {
      const b = el('button', { type: 'button', className: `kfh-guide__opt${on ? ' is-on' : ''}${swatch ? ' kfh-guide__opt--tex' : ''}` });
      b.setAttribute('aria-pressed', String(!!on));
      if (swatch) b.append(el('img', { src: swatch, alt: '', width: 24, height: 24, loading: 'lazy' }));
      b.append(el('span', {}, label));
      if (sub) b.append(el('small', { textContent: sub }));
      b.addEventListener('click', pick);
      return b;
    };
    const sameLen = (p, n) => p && p.variants.find((v) => !v.blended && v.nums.every((x) => Number(x) === n));
    const singleAt = (t, n) => t.single && t.single.variants.find((v) => v.n === n);
    const blendedSet = (t) => t.set && t.set.variants.find((v) => v.blended);
    const mid = (v) => { const ns = v.nums.map(Number).sort((a, b) => a - b); return ns[Math.floor(ns.length / 2)]; };

    function recommend() {
      const t = tex();
      const n = state.len;
      const extraFull = state.full === 1 ? 1 : 0;
      const long = n > 24; // sets stop at 24 in: singles only
      const cnt = long ? 4 + extraFull : (n <= 16 ? 2 : n <= 22 ? 3 : 4) + extraFull;
      const wantsCl = state.wear !== 1;
      const sl = Math.max(14, Math.min(24, n));
      const useSet = !long && cnt >= 3 && !!t.set;
      const blendV = useSet ? blendedSet(t) : null;
      const blended = useSet && state.blend && !!blendV;
      const set = useSet ? (blended ? blendV : sameLen(t.set, sl)) : null;
      const baseLen = blended ? mid(blendV) : useSet ? sl : n;
      const extra = useSet ? cnt - 3 : 0;
      const singles = useSet ? extra : cnt;
      const single = singleAt(t, baseLen);
      let cl = null;
      if (wantsCl && t.closure) {
        const want = Math.min(22, baseLen);
        cl = t.closure.variants.filter((v) => v.n <= want).sort((a, b) => b.n - a.n)[0] || t.closure.variants[0];
      }
      const items = [];
      if (useSet) items.push([set, 1]);
      if (singles) items.push([single, singles]);
      if (cl) items.push([cl, 1]);
      const ok = items.every(([v]) => v && v.available);
      const total = items.reduce((a, [v, q]) => a + (v ? v.price * q : 0), 0);
      // The same hair bought as single bundles (the set's lengths, one each), plus the extras and closure.
      const setLens = useSet ? (blended ? blendV.nums.map(Number) : [sl, sl, sl]) : [];
      const separately = setLens.reduce((a, x) => a + ((singleAt(t, x) || {}).price || 0), 0) + (single ? single.price * singles : 0) + (cl ? cl.price : 0);
      let big = useSet ? s.set.replace('[set]', set ? set.label : `${sl} in`) : s.bundles.replace('[count]', cnt).replace('[len]', n);
      if (extra) big += s.plusBundle.replace('[n]', extra);
      if (cl) big += s.plusClosure;
      const lensLen = blended ? blendV.label.replace(/ in$/, '') : useSet ? sl : n;
      let lens = s.lens.replace('[count]', cnt).replace('[len]', lensLen);
      if (cl) lens += s.lensClosure.replace('[closure]', t.closure.title).replace('[cl]', cl.n);
      const notes = [];
      if (long && s.longNote) notes.push(s.longNote);
      if (wantsCl && !t.closure && s.noClosure) notes.push(s.noClosure);
      if (state.unsure && cl && s.unsureWhy) notes.push(s.unsureWhy);
      return { ok, items, total, separately, useSet, blended, blendV, big, lens, notes, img: useSet ? t.setImg || t.img : t.img, sl };
    }

    function renderFinder() {
      if (!finder) return;
      const atResult = state.step >= STEPS;
      finder.querySelector('[data-kfh-finder-step]').textContent = atResult ? s.result : s.step.replace('[n]', state.step + 1).replace('[total]', STEPS);
      finder.querySelector('[data-kfh-finder-q]').hidden = atResult;
      finder.querySelector('[data-kfh-finder-result]').hidden = !atResult;
      finder.querySelector('[data-kfh-finder-back]').hidden = state.step === 0 || atResult;
      const match = finder.querySelector('[data-kfh-finder-match]');
      if (match) match.hidden = state.step !== 0 || atResult;
      const note = finder.querySelector('[data-kfh-finder-note]');
      if (note) note.hidden = !(state.step >= 2 && state.unsure && !atResult);
      if (!atResult) {
        const q = questions[state.step];
        finder.querySelector('[data-kfh-finder-title]').textContent = q.title;
        const opts = finder.querySelector('[data-kfh-finder-opts]');
        opts.dataset.step = state.step;
        if (state.step === 0) {
          opts.replaceChildren(...data.textures.map((t, i) => option(t.label, '', state.texPicked && state.tex === i, () => {
            Object.assign(state, { tex: i, texPicked: true, step: 1, blend: false });
            render();
          }, t.swatch)));
        } else if (state.step === 1) {
          opts.replaceChildren(...q.opts.map((l, i) => option(l, '', state.wear === i && !(i === 0 && state.unsure), () => {
            Object.assign(state, i === 2 ? { wear: 0, unsure: true, step: 2 } : { wear: i, unsure: false, step: 2 });
            render();
          })));
        } else if (state.step === 2) {
          opts.replaceChildren(...lengthsFor(tex()).map((n) => option(`${n} in`, landmarks[n] || '', state.len === n, () => { Object.assign(state, { len: n, step: 3 }); render(); })));
        } else {
          opts.replaceChildren(...q.opts.map((l, i) => option(l, q.subs[i], state.full === i, () => { Object.assign(state, { full: i, step: 4 }); render(); })));
        }
        return;
      }
      const t = tex();
      // Texture chips on the result: switch texture without starting over.
      $('[data-kfh-res-tex]').replaceChildren(...data.textures.map((x, i) => {
        const b = el('button', { type: 'button', className: 'kfh-guide__chip', textContent: x.name });
        b.setAttribute('aria-pressed', String(i === state.tex));
        b.addEventListener('click', () => {
          Object.assign(state, { tex: i, texPicked: true, blend: false });
          const ls = lengthsFor(data.textures[i]);
          if (!ls.includes(state.len)) state.len = ls[ls.length - 1];
          render();
        });
        return b;
      }));
      const r = recommend();
      const img = $('[data-kfh-res-img]');
      img.hidden = !r.img;
      if (r.img) { img.src = r.img; img.alt = t.label; }
      $('[data-kfh-res-big]').textContent = r.big;
      $('[data-kfh-res-lens]').textContent = r.lens;
      const price = $('[data-kfh-res-price]');
      const save = $('[data-kfh-res-save]');
      const saved = r.separately - r.total;
      if (r.useSet && saved > 0) {
        price.replaceChildren(`${s.separately} `, el('s', { textContent: money(r.separately) }), ' · ', el('b', { textContent: `${s.kit} ${money(r.total)}` }));
        save.textContent = s.save.replace('[amount]', money(saved));
        save.hidden = !s.save;
      } else {
        price.replaceChildren(el('b', { textContent: `${s.total} ${money(r.total)}` }));
        save.hidden = true;
      }
      const notes = $('[data-kfh-res-notes]');
      notes.replaceChildren(...r.notes.map((x) => el('p', { textContent: x })));
      notes.hidden = !r.notes.length;
      const add = $('[data-kfh-res-add]');
      const err = $('[data-kfh-res-error]');
      add.disabled = !r.ok;
      err.hidden = r.ok;
      if (!r.ok) err.textContent = s.soldOut;
      add.onclick = async () => {
        add.setAttribute('aria-busy', 'true');
        try {
          await window.KFH.addToCart(r.items.map(([v, q]) => ({ id: v.id, quantity: q })));
          err.hidden = true;
        } catch (e) {
          err.textContent = e.message;
          err.hidden = false;
        }
        add.removeAttribute('aria-busy');
      };
      // Alternatives: blended set <-> one length, and any 3 single bundles.
      const blendLink = $('[data-kfh-res-blend]');
      const same = r.useSet ? sameLen(t.set, r.sl) : null;
      const blendText = r.blended ? same && s.altSame.replace('[set]', same.label) : r.blendV && s.altBlend.replace('[set]', r.blendV.label);
      blendLink.hidden = !(r.useSet && blendText);
      if (!blendLink.hidden) blendLink.textContent = blendText;
      const singlesLink = $('[data-kfh-res-singles]');
      singlesLink.hidden = !(t.single && s.altSingles);
      if (!singlesLink.hidden) { singlesLink.textContent = s.altSingles; singlesLink.href = t.single.url; }
    }
    if (finder) {
      finder.querySelector('[data-kfh-finder-back]').addEventListener('click', () => { state.step = Math.max(0, state.step - 1); render(); });
      finder.querySelector('[data-kfh-finder-restart]').addEventListener('click', () => { Object.assign(state, { step: 0, wear: null, len: null, full: null, unsure: false, blend: false }); render(); });
      $('[data-kfh-res-blend]').addEventListener('click', () => { state.blend = !state.blend; render(); });
    }

    function render() { renderFinder(); }
    render();
  };

  // On the Bundle Guide the finder sits right under the hero (the guide is one section, so move it there).
  const place = (root) => { const hero = document.querySelector('.kfh-guide__hero'); if (hero && !root.dataset.placed) { root.dataset.placed = '1'; hero.after(root); } };
  const boot = () => document.querySelectorAll('[data-kfh-finder-root]').forEach((r) => { place(r); init(r); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
